import { createFileRoute } from '@tanstack/react-router'

import { RedirectPage } from '@/pages/redirect'

export const Route = createFileRoute('/redirect')({
    component: RedirectPage,
    validateSearch: (search) => {
        return {
            redirectUrl: search.redirectUrl ? String(search.redirectUrl) : undefined,
            state: search.state ? JSON.parse(String(search.state)) : undefined,
        }
    },
})
